<template>
  <div class="text-container">
    <p :class="['text-content']" :style="{ maxHeight }">
      {{ showText }}
      <span
        @click="toggleExpand"
        v-if="showMoreButton"
        class="overflowtext-btn"
      >{{isExpanded ? '收起' : '展开'}}</span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    item: Object, // 数据
  },
  data() {
    return {
      isExpanded: false,
      longText: '这是一个很长的文本示例，用于展示文字省略功能。当文本内容超过指定行数时，会自动显示省略号，并出现"更多"按钮。点击按钮可以展开全文，再次点击可以收起。这个功能在移动端非常实用，可以节省页面空间，同时给用户提供查看完整内容的选项。',
      maxLines: 4,
    };
  },
  computed: {
    showMoreButton() {
      // 这里可以添加逻辑判断是否需要显示更多按钮
      return this.item?.content?.length > 92;
    },

    showText() {
      if (this.item?.content?.length <= 92) {
        return this.item.content;
      }
      if (this.isExpanded) {
        return this.item?.content;
      }
      return `${this.item?.content?.slice(0, 92)}...`;
    },

    maxHeight() {
      return this.isExpanded ? undefined : `${this.maxLines * 42}px`;
    },
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
      console.log('this.isExpanded', this.isExpanded);
    },
  },
};
</script>

<style scoped>
.text-container {
  position: relative;
  padding: 16px;
  background-color: #f5f5f5;
  margin-left: 24px;
  margin-right: 24px;
  border-radius: 16px;
  display: flex;
}

.text-content {
  font-size: 28px;
  line-height: 42px;
  color: #333;
  text-overflow: ellipsis;
  overflow: hidden;
  word-wrap: break-word;
  word-break: break-all;
}

.overflowtext-btn {
  color: #006eff;
   line-height: 42px;
  font-size: 28px;
}
</style>
